import { DiscoverySearchProps, DiscoverySearchType } from './index.type';
import { useDebounce } from 'src/hooks/useDebounce';
import { useNotification } from 'src/hooks/useNotification';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react'
import useCallApi from 'src/hooks/useCallApi';

const DiscoverySearch = ({ searchQuery, handleSelect, selectedFilter, allData }: DiscoverySearchProps) =>
{
    const { t, i18n } = useTranslation();
    const { callApi, callApiLoading, data, setData, isError, setCallApiLoading } = useCallApi();
    const debouncedSearch = useDebounce(searchQuery, 500);
    const { notification, contextHolder } = useNotification();

    const handleSearch = async () =>
    {

        if (selectedFilter === DiscoverySearchType.Category)
        {
            setCallApiLoading(true)
            requestAnimationFrame(() =>
            {
                let categoryList = allData.filter((category: any) =>
                {
                    return (i18n.language === "fr" ? category.categoryFr : category.categoryEn).toLowerCase().includes(debouncedSearch.toLowerCase())
                })
                setData(categoryList || []);
                setCallApiLoading(false)
            });
        }

        if (selectedFilter === DiscoverySearchType.Report)
        {
            setCallApiLoading(true)
            let res = await callApi(
                {
                    //v endpoint: "ReportList",
                    endpoint: "SearchList",
                    forGlobalSearch: true,
                    query: debouncedSearch,
                    //v extraHeaders: {
                    //     searchFilter: debouncedSearch,
                    //     pagesize: 50,
                    //     pageindex: 1,
                    // }
                });
            //v setData(res?.data || []);
            setData(res || []);
            setCallApiLoading(false)
        }
    };

    const handleOnClick = (item: any) =>
    {
        handleSelect(
            {
                id: item.id,
                name: selectedFilter === DiscoverySearchType.Category
                    ? (i18n.language === "fr" ? item.categoryFr : item.categoryEn)
                    : (i18n.language === "fr" ? item.nameFr : item.nameEn)
            }
        )
    }

    //Effect to handle search
    useEffect(() =>
    {
        if (debouncedSearch === "")
        {
            setData([]);
            return;
        }
        handleSearch();
    }, [debouncedSearch]);

    //Effect to handle error
    useEffect(() =>
    {
        if (isError.status)
        {
            notification({ content: { name: t("t2"), message: isError.message }, type: 'error' })
        }
    }, [isError]);

    return (
        <>
            {debouncedSearch !== "" && (
                <ul className="absolute bg-[#fbfbfb] max-h-96 overflow-y-auto scroll-smooth scroll-thin  z-10 general-shadow m-0 p-0 w-[400px]">
                    {
                        callApiLoading
                            ? <li className="w-full py-3 pl-3 pr-2 cursor-pointer text-sm">{t("loading")}</li>
                            : <>
                                {data?.length === 0 && searchQuery !== "" && (
                                    <li className="w-full py-3 pl-3 pr-2 cursor-pointer text-sm">{t("no_Matching_Results")}</li>
                                )}
                                {Array.isArray(data) && data.map((item: any) => (
                                    <li key={item.id}
                                        className="w-full py-3 pl-3 pr-2 cursor-pointer hover:text-[#ed1a3b] hover:bg-[#fff2ee] text-sm"
                                        onClick={() => handleOnClick(item)}
                                    >
                                        {selectedFilter === DiscoverySearchType.Category ? (
                                            <span>{i18n.language === "fr" ? item.categoryFr : item.categoryEn}</span>
                                        ) : (
                                            <span>{i18n.language === "fr" ? item.nameFr : item.nameEn}</span>
                                        )}
                                    </li>
                                ))}
                            </>
                    }
                </ul>
            )}
            {contextHolder}
        </>
    )
}

export default DiscoverySearch